import React from "react";
import Dropzone from "react-dropzone";
import Required from "./Required";

export default function ManualFileField({
  input,
  label,
  required,
  meta: { touched, error, warning },
  stack,
  accept,
  maxSize,
}) {
  let files = input.value || [];
  if (typeof files === "string" && files !== "") {
    try {
      files = JSON.parse(files);
    } catch (e) {
      files = [];
    }
  }

  function onDrop(acceptedFiles) {
    input.onChange([...files, ...acceptedFiles]);
  }

  function removeFile(index) {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    input.onChange(newFiles);
  }

  return (
    <div className={`form-group ${input.name.split(".").join("_")}`}>
      <label
        htmlFor={label}
        className={`${!stack && "col-sm-3"} control-label`}
      >
        {label} {required && <Required />}
      </label>
      <div className={`${!stack && "col-sm-9"}`}>
        <ul className="list-group">
          {files.length === 0 && (
            <p className="well well-sm">No files selected</p>
          )}
          {files.map((file, i) => {
            const fileName = file.name || file.detail?.name || "Unknown file";
            const isExisting = !!(file.id && file.detail);
            
            return (
              <li key={i} className="list-group-item">
                <span>
                  <i className="fa fa-file-excel-o" /> {fileName}
                  {isExisting && (
                    <a 
                      href={`${process.env.REACT_APP_BASE_API}/download/${file.id}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-link btn-xs"
                      style={{ marginLeft: '10px' }}
                    >
                      <i className="fa fa-download" /> Download
                    </a>
                  )}
                </span>
                <a
                  href="#top"
                  onClick={(e) => {
                    e.preventDefault();
                    removeFile(i);
                  }}
                  className="text-danger pull-right"
                >
                  <i className="fa fa-remove" /> Delete
                </a>
              </li>
            );
          })}
        </ul>
        <Dropzone
          name={label}
          style={{ marginBottom: 0 }}
          className="well"
          data-cy="dropzone"
          accept={accept}
          maxSize={maxSize}
          onDrop={onDrop}
        >
          <div>
            Try dropping some files here, or click to select files to upload.
          </div>
        </Dropzone>
        {touched &&
          ((error && <div className="alert alert-danger">{error}</div>) ||
            (warning && <div className="alert alert-warning">{warning}</div>))}
      </div>
    </div>
  );
}
